module.exports = __webpack_public_path__ + "static/media/bg.3e9d1dc0.png";